import crawlApi, { type CrawlRequestBody } from './crawlApi';

const diagramApi = crawlApi.injectEndpoints({
  endpoints: build => ({
    getDiagram: build.mutation<unknown, CrawlRequestBody>({
      query: (body: CrawlRequestBody) => ({
        url: `/khazesh/v3/referal_diagram/`,
        method: 'POST',
        body: body
      })
    }),
    getGraph: build.mutation<unknown, CrawlRequestBody>({
      query: (body: CrawlRequestBody) => ({
        url: `/khazesh/v3/referal_diagram/anchor_graph`,
        method: 'POST',
        body: body
      })
    })
  }),
  overrideExisting: false
});

export const { useGetDiagramMutation, useGetGraphMutation } = diagramApi;
export default diagramApi;
